// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c52c79>:not(:last-child){border-bottom-left-radius:0;border-bottom-right-radius:0}.c52c79>:not(:first-child){margin-top:1px;border-top-left-radius:0;border-top-right-radius:0}.c52c79.cee760>:not(:first-child){margin-top:.25em}", ""]);
// Exports
exports.locals = {
	"group": "c52c79",
	"has-gap": "cee760",
	"hasGap": "cee760"
};
module.exports = exports;
